export default {
  token: null,

  uploadInfo: null,
  uploads: [],

  companies: [],
  company: {},

  subSystems: [],

  companyTypes: [],

  relationFields: [],
  relationTables: [],
  relationForeignKeys: [],
  relationParentTables: [],
  relationChildTables: [],
  relationParentForeignKeys: [],
  databases: [],

  // Menu ---------------------------------------------------------------------
  menus: [],
  clubPermissions: [],

  // Backup Import / Export ---------------------------------------------------
  targetBranches: [],
  sourceBranches: [],
  backupImport: null,
  backupImportId: null,
  backupUploadProgress: 0,
  backupUploading: false,
  backupExporting: false,
};
